<template>
    <setup_content title="Расчет совокупного износа">

		<importWear ref="import_wear" :id="id" v-on:need_refresh="() => $emit('need_refresh')"/>

        <setup_frame title="Настройка расчета физического износа">

            <div class="element-row mb-3">
                <label class="element-row_label"><span>Выберите способ расчет</span></label>
                <div class="element-row_fields">
                    <b-form-group class="mb-0" v-slot="{ ariaDescribedby }" :disabled="!check_roles([ 'model' ]) || not_editable">

                        <b-form-radio v-model="data.type" :aria-describedby="ariaDescribedby" name="methods" value="effective-age"
                            @change="(value) => set_value('type', value)"
                        >
                            Расчет методом эффективного возраста (МУ П/0336 п.46.4)
                            <base-icon name="info" class="natural-400" id="effective-age" />
                            <b-tooltip target="effective-age" triggers="hover" container="fullscreen" placement="right" custom-class="effective-age__tooltip">
                                <strong>Физический износ</strong> = (Дата оценки - Год завершения строительства или Год ввода в эксплуатацию по завершении строительства)
                                <br>/ Срок экономической жизни
                            </b-tooltip>
                        </b-form-radio>

						<!-- 3780, # 62
                        <b-form-radio v-model="data.type" :aria-describedby="ariaDescribedby" name="methods" value="accumulation"
                            @change="(value) => set_value('type', value)"
                        >
                            Модель накопления физического износа (Приложение №8)
                        </b-form-radio>
						-->

                    </b-form-group>
                </div>
            </div>

            <element_row
                title="Физический износ, в случае отсутствия данных для расчета" :data="data.custom"
                :validation="fields['custom']" v-on:set_value="(key, value) => set_value(`custom.${key}`, value)"
                :readonly="!check_roles([ 'model' ]) || not_editable"
            />

        </setup_frame>

        <setup_frame title="Настройка расчета внешнего устаревания">
            <div class="element-row">
                <label class="element-row_label"><span>Выбор характеристик / ценообразующих факторов</span></label>
                <div class="element-row_fields">
                    <v-select class="w-50" :options="attrs" :disabled="!check_roles([ 'model' ]) || not_editable" :value="external_wear_attr" @input="(value) => set_value('external_wear_attr', value.key)" :clearable="false" required />
                </div>
            </div>
            <main_table
                :attrs="[external_wear_attr, { key : 'external_wear', label : 'Внешнее устаревание'}]"
                :elements="data.external_wear_items"
                :count="data.external_wear_items.length" :initial_per_page=5
            >
                <template v-slot:nav_end>
                    <b-nav>
						<b-button title="Импорт" v-if="check_roles([ 'model' ]) && !not_editable" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" v-on:click="() => import_wear(true)"><base-icon name="upload" /></b-button>
						<b-button title="Экспорт таблицы" v-if="!$root.readonly" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" v-on:click="() => export_wear(true)"><base-icon name="download" /></b-button>
                    </b-nav>
                </template>

                <template v-slot:table_cell_params="cell_data" >
                    <table_input v-if="cell_data.data.field.key == 'external_wear'"
                        :value="cell_data.data.item.external_wear" :item="cell_data.data.item"
                        v-on:change="value => set_wear(cell_data.data.item, value, true)"
                        :validation="fields.table" :readonly="!check_roles([ 'model' ]) || not_editable"
                     />
                    <span v-else>{{ cell_data.data.value }}</span>
                </template>
            </main_table>
        </setup_frame>

        <setup_frame title="Настройка расчета функционального устаревания">
            <div class="element-row">
                <label class="element-row_label"><span>Выбор характеристик / ценообразующих факторов</span></label>
                <div class="element-row_fields">
                    <v-select class="w-50" :options="attrs" :disabled="!check_roles([ 'model' ]) || not_editable" :value="functional_wear_attr" @input="(value) => set_value('functional_wear_attr', value.key)" :clearable="false" required />
                </div>
            </div>
            <main_table
                :attrs="[functional_wear_attr, { key : 'functional_wear', label : 'Функциональное устаревание'}]"
                :elements="data.functional_wear_items"
                :count="data.functional_wear_items.length" :initial_per_page=5
            >
                <template v-slot:nav_end>
                    <b-nav>
                        <b-button title="Импорт" v-if="check_roles([ 'model' ]) && !not_editable" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" v-on:click="() => import_wear(false)"><base-icon name="upload" /></b-button>
                        <b-button title="Экспорт таблицы" v-if=" !$root.readonly" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" v-on:click="() => export_wear(false)"><base-icon name="download" /></b-button>
                    </b-nav>
                </template>

                <template v-slot:table_cell_params="cell_data" >
                    <table_input v-if="cell_data.data.field.key == 'functional_wear'"
                        :value="cell_data.data.item.functional_wear" :item="cell_data.data.item"
                        v-on:change="value => set_wear(cell_data.data.item, value, false)"
                        :validation="fields.table" :readonly="!check_roles([ 'model' ]) || not_editable"
                     />
                    <span v-else>{{ cell_data.data.value }}</span>
                </template>
            </main_table>
        </setup_frame>

    </setup_content>
</template>

<script>
import api from "../../../../../../api"
import main_table from "../../../../../widgets/main_table"
import importWear from "./import_wear"
import setup_content from '../../setup_assets/content'
import setup_frame from '../../setup_assets/frame'
import element_row from "../../../../../widgets/element-row"
import table_input from "../../../../../widgets/table_input"

export default
{
    props :
    {
		id : String,
        data : Object,
        not_editable : Boolean,
    },
    components:
    {
        main_table,
		importWear,
        setup_content,
        setup_frame,
        table_input,
        element_row
    },
    data()
    {
        return {

			service : "cadastral_cost_evaluation",

            attrs : 
            [
                { key : "cad_quarter", label : "Кадастровый квартал", },
                { key : "OKTMO", label : "ОКТМО" },
                { key : "OKATO", label : "ОКАТО" },
                { key : "KLADR", label : "КЛАДР" },
            ],

            fields: {
                "custom":
                {
                    check: (value) => api.check_number({ value : value, accuracy : 2, gte : 0, lte : 1 }),
                    msg: "От 0 до 1, до 2-х знаков после запятой"
                },

                table :
                {
                    check : (value) => api.check_number({ value : value, accuracy : 2, gte : 0, lte : 1 }),
                    msg : "От 0 до 1, до 2-х знаков после запятой"
                }
            }
        }
    },
    computed:
    {
        external_wear_attr()
        {
            return this.attrs.find(e => e.key == this.data.external_wear_attr)
        },
        functional_wear_attr()
        {
            return this.attrs.find(e => e.key == this.data.functional_wear_attr)
        }
    },

    methods :
    {
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },
		
        set_value(key, value)
        {
            this.$emit("set_value", key, value)
        },

		set_wear(elem, value, is_external)
		{
            if (this.check_roles([ 'model' ]) && !this.not_editable)
                api.call(this, this.service, "set_wear", { id : this.id, is_external : is_external, elem : elem, value : value }, () => this.$emit("need_refresh"))
		},

		import_wear(is_external)
		{
			const wear_attr = is_external ? this.external_wear_attr : this.functional_wear_attr

			this.$refs.import_wear.execute(wear_attr, is_external)
		},

		export_wear(is_external)
		{
			api.call(this, this.service, "export_wear", { id : this.id, is_external : is_external }, api.open_response_url)
		},
    }
}
</script>

<style>
.effective-age__tooltip .tooltip-inner
{
    max-width: 300px;
}
</style>
